import { Link } from "react-router-dom";
import { ArrowRight, Target, Zap } from "lucide-react";

export function RutaSelectaHeroCards() {
  return (
    <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 text-left">
      {/* Tarjeta 1: Ruta Selecta de aquí al ENARM */}
      <Link
        to="/planes"
        className="group relative flex flex-col justify-between overflow-hidden rounded-2xl border-2 border-primary/30 bg-gradient-to-br from-primary/10 via-primary/5 to-background p-4 shadow-sm transition-all duration-200 hover:border-primary hover:shadow-md hover:scale-[1.01]"
      >
        <div className="absolute top-0 right-0 rounded-bl-xl bg-primary px-2 py-0.5 text-[9px] font-black uppercase tracking-wider text-primary-foreground">
          Colección 39 Días
        </div>
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-xl bg-primary text-primary-foreground shadow-sm">
              <Target className="h-4 w-4" />
            </span>
            <div>
              <p className="text-[10px] font-bold uppercase tracking-wider text-primary">Ruta Selecta 2026</p>
              <h2 className="text-sm font-black text-foreground leading-tight">De aquí al ENARM</h2>
            </div>
          </div>
          <p className="mt-2 text-xs leading-relaxed text-muted-foreground">
            Flashcards y preguntas seleccionadas de alta rentabilidad para cubrir los temas con mayor peso en el examen.
          </p>
        </div>
        <div className="mt-3 flex items-center justify-between border-t border-border/60 pt-2 text-xs">
          <span className="font-bold text-primary flex items-center gap-1">
            Ver Colección <ArrowRight className="h-3 w-3 transition-transform group-hover:translate-x-1" />
          </span>
          <span className="text-[10px] text-muted-foreground">3 Días Gratis</span>
        </div>
      </Link>

      {/* Tarjeta 2: Ruta Selecta Exprés */}
      <Link
        to="/planes"
        className="group relative flex flex-col justify-between overflow-hidden rounded-2xl border-2 border-amber-500/30 bg-gradient-to-br from-amber-500/10 via-amber-500/5 to-background p-4 shadow-sm transition-all duration-200 hover:border-amber-500 hover:shadow-md hover:scale-[1.01]"
      >
        <div className="absolute top-0 right-0 rounded-bl-xl bg-amber-500 px-2 py-0.5 text-[9px] font-black uppercase tracking-wider text-white">
          Recta Final
        </div>
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-xl bg-amber-500 text-white shadow-sm">
              <Zap className="h-4 w-4" />
            </span>
            <div>
              <p className="text-[10px] font-bold uppercase tracking-wider text-amber-600 dark:text-amber-400">Ruta Selecta Exprés</p>
              <h2 className="text-sm font-black text-foreground leading-tight">Repaso Ultrarrápido</h2>
            </div>
          </div>
          <p className="mt-2 text-xs leading-relaxed text-muted-foreground">
            Flashcards cloze de memorización activa y reactivos rápidos para afianzar conceptos clave en los últimos días.
          </p>
        </div>
        <div className="mt-3 flex items-center justify-between border-t border-border/60 pt-2 text-xs">
          <span className="font-bold text-amber-600 dark:text-amber-400 flex items-center gap-1">
            Iniciar Exprés <ArrowRight className="h-3 w-3 transition-transform group-hover:translate-x-1" />
          </span>
          <span className="text-[10px] text-muted-foreground">Perlas de Examen</span>
        </div>
      </Link>
    </div>
  );
}
